import React from 'react'

export default function Atthacment() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#03555E" fillOpacity="0.1" />
      <g clipPath="url(#clip0_5335_6771)">
        <path d="M12.1859 7.44331L11.6755 6.93285L7.43184 11.1764C6.90674 11.7015 6.90674 12.5558 7.43184 13.081C7.6859 13.3351 8.0241 13.475 8.38415 13.475C8.74419 13.475 9.08239 13.335 9.33648 13.081L15.0357 7.38158C15.8434 6.57384 15.8434 5.25965 15.0357 4.45196C14.228 3.64427 12.9138 3.64427 12.1061 4.45196L5.17662 11.3815C4.08631 12.4718 4.08631 14.2459 5.17662 15.3362C5.72179 15.8813 6.4379 16.1539 7.154 16.1539C7.87011 16.1539 8.58621 15.8814 9.13133 15.3362L14.6051 9.86244L14.0946 9.35198L8.6209 14.8257C7.81203 15.6346 6.4959 15.6346 5.68708 14.8257C4.87823 14.0169 4.87823 12.7008 5.68708 11.8919L12.6165 4.96244C13.1428 4.43624 13.999 4.43624 14.5253 4.96244C15.0515 5.48867 15.0515 6.34492 14.5253 6.87117L8.82597 12.5705C8.70823 12.6883 8.55131 12.7531 8.38412 12.7531C8.21693 12.7531 8.05999 12.6883 7.94229 12.5705C7.69866 12.3269 7.69866 11.9304 7.94229 11.6868L12.1859 7.44331Z" fill="black" fillOpacity="0.6" />
      </g>
      <defs>
        <clipPath id="clip0_5335_6771">
          <rect width="12.3077" height="12.3077" fill="white" transform="translate(3.84619 3.84619)" />
        </clipPath>
      </defs>
    </svg>
  )
}
